import {IconButton} from 'platform/components';
import {match} from 'ts-pattern';

import {suffixTestId, type Nullish, type TestIdProps} from 'shared/web';

import {ToolpanelType} from '../../../../types/ToolpanelType';

export type MobilePresetsButtonProps = TestIdProps & {
  isPresetActive: boolean;
  activePanel: ToolpanelType | Nullish;
  onTogglePanel: (panel: ToolpanelType) => void;
};

/**
 * Mobile preset trigger button shown in the grid header.
 *
 * Tapping slides in the presets panel in the same sidebar used by
 * Settings and Column Settings — no dialog is opened.
 *
 * Priority rules:
 * - Active preset → 'primary'
 * - Panel open, no active preset → 'secondary'
 * - Otherwise → undefined
 */
export function MobilePresetsButton(props: MobilePresetsButtonProps) {
  const handleToggle = () => props.onTogglePanel(ToolpanelType.presets);

  const priority = match({
    isPresetActive: props.isPresetActive,
    isPanelOpen: props.activePanel === ToolpanelType.presets,
  })
    .with({isPresetActive: true}, () => 'primary' as const)
    .with({isPanelOpen: true}, () => 'secondary' as const)
    .otherwise(() => undefined);

  return (
    <IconButton
      icon="action/build"
      priority={priority}
      onClick={handleToggle}
      data-testid={suffixTestId('mobilePresetsButton', props)}
    />
  );
}
